import PermIdentity from '@material-ui/icons/PermIdentity';
import {UnitsOfMeasurementCreate} from "./UnitsOfMeasurementCreate";
import {UnitsOfMeasurementEdit} from "./UnitsOfMeasurementEdit";
import {UnitsOfMeasurementList} from "./UnitsOfMeasurementList";


// import {
//     ShowGuesser,
//     // EditGuesser
// } from 'react-admin';


// import {BaseListIdNameEdit} from "./BaseListIdNameEdit";
// import {BaseListIdNameCreate} from "./BaseListIdNameCreate";

const resource = {
    list: UnitsOfMeasurementList,
    create: UnitsOfMeasurementCreate,
    edit: UnitsOfMeasurementEdit,
    // show: ShowGuesser,
    icon: PermIdentity,
};

export default resource;